import { render } from "./Home.vue?vue&type=template&id=2e605595&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2e605595&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e605595"]])

export default __exports__